import { Builder, Input } from '@builder.io/sdk';
import { LandingPageHero } from './LandingPageHero';
import { landingPageFormInputs } from '../LandingPageForm/LandingPageForm.registry';

const getProcessedLandingPageFormInputs = (): Input[] => {
  const filterExcludedFields = (inputs: Input[]): Input[] => {
    const excludedFields = ['heading', 'subHeading'];
    return inputs.filter((input) => !excludedFields.includes(input.name));
  };

  const overrideDefaults = (input: Input): Input => {
    if (input.name === 'regLabel') {
      return {
        ...input,
        defaultValue: '',
        helperText: 'Label shown above the registration input on desktop only. Leave empty to hide.',
      };
    }

    if (input.name === 'formIntroText') {
      return {
        ...input,
        defaultValue: 'To get started simply enter your reg...',
        helperText:
          'Text shown above the registration input. On mobile, this becomes the regLabel. On desktop, shows as intro text.',
      };
    }

    if (input.name === 'useCardStyle') {
      return {
        ...input,
        defaultValue: true,
      };
    }

    if (input.name === 'showDurationPicker') {
      return {
        ...input,
        helperText:
          'Show or hide the duration picker on desktop (always hidden on mobile). Defaults to showing on desktop.',
      };
    }

    return input;
  };

  return filterExcludedFields(landingPageFormInputs).map(overrideDefaults);
};

const LandingPageHeroConfig = {
  name: 'Landing Page Hero',
  inputs: [
    {
      name: 'layout',
      friendlyName: 'Layout',
      type: 'enum',
      defaultValue: '1',
      enum: [
        {
          label: 'Layout 1 (Content Far Left, Form Far Right)',
          value: '1',
        },
        {
          label: 'Layout 2 (Form Left, Content Right - Side by Side)',
          value: '2',
        },
        {
          label: 'Layout 3 (Content Left, Form Right - Side by Side)',
          value: '3',
        },
      ],
      helperText: 'Layout 1 mobile: Content top, form bottom. Layouts 2 & 3 mobile: Content & form stacked at top',
    },
    {
      name: 'heading',
      friendlyName: 'Heading',
      type: 'string',
      required: true,
      defaultValue: 'Temporary Vehicle Insurance',
    },
    {
      name: 'subheading',
      friendlyName: 'Subheading',
      type: 'string',
      defaultValue: 'Get affordable cover, unbelievably fast',
    },
    {
      name: 'backgroundImage1',
      friendlyName: 'Background Image (Layout 1)',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      helperText: 'Background image for Layout 1 only',
    },
    {
      name: 'backgroundImage2',
      friendlyName: 'Background Image (Layouts 2 & 3)',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      helperText: 'Background image for Layout 2 and Layout 3',
    },
    ...getProcessedLandingPageFormInputs(),
  ],
};

Builder.registerComponent(LandingPageHero, LandingPageHeroConfig);
